<!-- SECTION HERO - Intro immersive -->
<section class="about-hero">
  <div class="overlay">
    <h1>À propos de nous</h1>
    <p><span class="afrotech">AfroTech Hub</span> est un média engagé qui révèle le potentiel Tech du continent africain.</p>
  </div>
</section>

<!-- SECTION INTRO - Ce qu'on fait -->
<section class="intro-section container">
  <div class="intro-wrapper">
    <h2>✨ Ce que nous faisons</h2>
    <p>AfroTech Hub met en lumière les avancées technologiques en Afrique à travers des <strong>vidéos, interviews et actualités</strong>. Nous partageons chaque semaine les tendances Tech africaines avec <strong>AfroTech Hebdo</strong>.</p>
    <p><span class="afrotech">AfroTech Hub</span>, c’est aussi un ensemble de rubriques pensées pour inspirer, former et connecter les talents africains à l’écosystème Tech.</p>
  </div>
</section>

<!-- SECTION RUBRIQUES - Blocs interactifs -->
<section class="rubriques-section container">
  <div class="rubrique-card">
    <h3>🎥 AfroTech Talents</h3>
    <p>Des interviews inspirantes de talents africains et de la diaspora qui créent les solutions de demain.</p>
  </div>
  <div class="rubrique-card">
    <h3>📚 AfroTech Learn</h3>
    <p>Des vidéos pédagogiques de moins de 3 minutes pour comprendre des sujets Tech, en lien avec les réalités africaines.</p>
  </div>
  <div class="rubrique-card">
    <h3>📢 AfroTech News </h3>
    <p>Des actus, hebdo, tendances et analyses clés repérées chaque semaine pour mieux comprendre l’écosystème tech africain.</p>
  </div>
  <div class="rubrique-card">
    <h3>🛠️ AfroTech Solutions</h3>
    <p>Nous aidons les entreprises et entrepreneurs à se digitaliser (IA, développement web, communication...)</p>
  </div>
</section>

<!-- SECTION MISSION -->
<section class="mission-section container">
  <div class="mission-wrapper">
    <div class="text-content">
      <h2>🎯 Notre mission</h2>
      <p>Accompagner la nouvelle génération africaine à s’approprier les outils du numérique et à bâtir des projets à fort impact.</p>
      <ul>
        <li>🎓 Former les talents avec des contenus pédagogiques accessibles</li>
        <li>🚀 Mettre en valeur les startups et projets africains innovants</li>
        <li>🌍 Créer des ponts entre l’Afrique et sa diaspora tech</li>
      </ul>
    </div>
    <div class="logo-bubble">
      <img src="assets/images/afro-black.png" alt="Logo AfroTech Hub" />
    </div>
  </div>
</section>

<!-- SECTION VALEURS -->
<section class="values-section">
  <div class="container">
    <h2 class="section-title">Nos valeurs</h2>
    <div class="values-grid">
      <div class="value-card">
        <h3>Authenticité</h3>
        <p>Chaque histoire est vraie et enracinée dans le vécu de la tech africaine.</p>
      </div>
      <div class="value-card">
        <h3>Excellence</h3>
        <p>Nous mettons en avant le meilleur de l’Afrique technologique.</p>
      </div>
      <div class="value-card">
        <h3>Innovation</h3>
        <p>Nous croyons en la capacité de l’Afrique à inventer son futur.</p>
      </div>
    </div>

    <div class="cta-contact mt-5 text-center">
      <h4>Tu veux en savoir plus ou collaborer avec nous ?</h4>
      <a routerLink="/contact" class="btn btn-primary mt-3">Contacte-nous</a>
    </div>
  </div>
</section>
